export default "__VITE_ASSET__Ca$90PCZ__"